module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-ties.ce281745.png";